import { LinkButton, Responsive, UIHeading4 } from '@cian/ui-kit';
import * as React from 'react';
import cn from 'classnames';
import { ContentWrapper } from '../../components/ContentWrapper';
import { LandingBlock } from '../../components/LandingBlock';
import * as styles from './SuburbanMortgageBanner.css';

interface ISuburbanMortgageBannerProps {
  url: string;
}

export const SuburbanMortgageBanner: React.FC<ISuburbanMortgageBannerProps> = ({ url }) => {
  return (
    <ContentWrapper>
      <LandingBlock>
        <a
          href={url}
          target="_blank"
          rel="nofollow noopener noreferrer"
          className={styles['link-area']}
          data-name="SuburbanMortgageBanner"
        >
          <div className={styles['banner-container']}>
            <Responsive desktop>
              <div className={styles['inner']}>
                <div className={styles['left-desktop-image']} />
                <div className={styles['text-block']}>
                  <div className={styles['mortgage-logo']} />
                  <div className={styles['text']}>
                    <UIHeading4 fontWeight="bold" color="white_100">
                      Ипотека на дома на вторичном рынке со скидкой
                    </UIHeading4>
                  </div>
                  <LinkButton theme="fill_white_primary" href={url} target="_blank" size="XS">
                    Хочу скидку
                  </LinkButton>
                </div>
                <div className={styles['right-desktop-image']} />
              </div>
            </Responsive>
            <Responsive tablet>
              <div className={styles['banner']}>
                <UIHeading4 fontWeight="bold" color="white_100">
                  Ипотека на дома на вторичном рынке со скидкой
                </UIHeading4>
                <div className={styles['button']}>
                  <LinkButton theme="fill_white_primary" href={url} target="_blank" size="XS">
                    Хочу скидку
                  </LinkButton>
                </div>
              </div>
            </Responsive>
            <Responsive phone>
              <div className={cn(styles['banner'], styles['mobile-banner'])}>
                <UIHeading4 fontWeight="bold" color="white_100">
                  Ипотека на дома <br />
                  со скидкой
                </UIHeading4>
              </div>
            </Responsive>
          </div>
        </a>
      </LandingBlock>
    </ContentWrapper>
  );
};
